import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  nouveau: "bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900",
  en_attente_assignation: "bg-neutral-200 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-100",
  ouvert: "bg-blue-100 text-blue-900 dark:bg-blue-950 dark:text-blue-200",
  en_cours: "bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200",
  en_attente_client: "bg-purple-100 text-purple-900 dark:bg-purple-950 dark:text-purple-200",
  en_attente_interne: "bg-neutral-200 text-neutral-800 dark:bg-neutral-800 dark:text-neutral-200",
  cloture: "bg-green-100 text-green-900 dark:bg-green-950 dark:text-green-300",
  rouvert: "bg-red-100 text-red-900 dark:bg-red-950 dark:text-red-300",
  archive: "bg-neutral-100 text-neutral-500 dark:bg-neutral-800 dark:text-neutral-400",
};

const PRIORITY_STYLES = {
  basse: "bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300",
  normale: "bg-neutral-200 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-100",
  haute: "bg-orange-100 text-orange-900 dark:bg-orange-950 dark:text-orange-300",
  urgente: "bg-red-600 text-white",
};

const ROLE_LABELS = {
  super_admin: "Super Admin",
  company_admin: "Admin Société",
  manager: "Manager",
  collaborator: "Collaborateur",
  client_user: "Client",
  system: "Système",
};

export const STATUS_LABELS = {
  nouveau: "Nouveau",
  en_attente_assignation: "En attente d'assignation",
  ouvert: "Ouvert",
  en_cours: "En cours",
  en_attente_client: "En attente client",
  en_attente_interne: "En attente interne",
  cloture: "Clôturé",
  rouvert: "Rouvert",
  archive: "Archivé",
};

export const PRIORITY_LABELS = { basse: "Basse", normale: "Normale", haute: "Haute", urgente: "Urgente" };
export { ROLE_LABELS };

function Pill({ className, children, testid }) {
  return (
    <span data-testid={testid} className={cn("inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-semibold whitespace-nowrap", className)}>
      {children}
    </span>
  );
}

export function StatusBadge({ status }) {
  return <Pill testid={`status-badge-${status}`} className={STATUS_STYLES[status] || STATUS_STYLES.nouveau}>{STATUS_LABELS[status] || status}</Pill>;
}

export function PriorityBadge({ priority }) {
  return <Pill testid={`priority-badge-${priority}`} className={PRIORITY_STYLES[priority] || PRIORITY_STYLES.normale}>{PRIORITY_LABELS[priority] || priority}</Pill>;
}

export function RoleBadge({ role }) {
  const styles = {
    super_admin: "bg-red-600 text-white",
    company_admin: "bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900",
    manager: "bg-neutral-200 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-100",
    collaborator: "bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-200",
    client_user: "bg-blue-100 text-blue-900 dark:bg-blue-950 dark:text-blue-200",
  };
  return <Pill testid={`role-badge-${role}`} className={styles[role] || styles.collaborator}>{ROLE_LABELS[role] || role}</Pill>;
}
